import React from 'react';
import HamburgerMenu from 'react-hamburger-menu';




class Hamburger extends React.Component {
    constructor(props) {
        super(props);
    this.state = {
        open: false,
        visible: false
    };

   
}

    handleClick() {

        let xVar = document.getElementById('menu');
        let yVar = document.getElementById('hamBack');

        if (xVar.style.visibility = 'hidden') {
        this.setState({
            open: !this.state.open
        });
    }

        if (!this.state.open) {
            xVar.style.visibility = 'visible';
            yVar.style.backgroundColor = "transparent";
        }
        else {
            xVar.style.visibility = 'hidden'
            yVar.style.backgroundColor = 'rgba(0,0,0,0.5)'

        }
        
    }

    pointer(e) {
        e.target.style.cursor = 'pointer';
    }

    render() {
        

        return (


<div id="hamBack" onMouseOver={this.pointer} style={{textAlign: "right", marginRight: "-15px", marginTop: "15px", zIndex: "99", paddingTop: "10px", width: "50px", height: "45px", backgroundColor: "rgba(0,0,0,0.5)"}}>
<HamburgerMenu
    isOpen={this.state.open}
    menuClicked={this.handleClick.bind(this)}
    width={36}
    height={25}
    strokeWidth={2}
    rotate={0}
    color='white'
    borderRadius={0}
    animationDuration={0.5}
/>
</div>

        )}}

export {Hamburger}